import { Cookies } from "react-cookie";

export default function baseRequest() {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const account = cookies.get("account");
  const b_ts = new Date().getTime();
  const baseRequest = {
    b_mid: account?.mid,
    b_ch: "op",
    b_ts: b_ts,
    b_token: token,
  };
  return baseRequest;
}
